function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.4062 19.9062C11.7812 20.0625 12.1875 20.0625 12.5625 19.9062C15.25 18.7812 19.5 14.9375 19.5 8C19.5 7.40625 19.125 6.875 18.5625 6.625L12.5625 4.125C12.4062 4.0625 12.1562 4.03125 12 4.03125C11.8125 4.03125 11.5625 4.0625 11.4062 4.125L5.40625 6.625C4.84375 6.875 4.5 7.40625 4.5 8C4.5 14.2188 8.0625 18.5 11.4062 19.9062ZM12 5.5L18 8C18 13.4375 14.9062 17.2812 12 18.5C8.9375 17.25 6 13.3125 6 8L12 5.5Z",
  fill: "#191B1C"
}));

var SvgIcnDefence = function SvgIcnDefence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnDefence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-defence.252c1e0e.svg";
export { ForwardRef as ReactComponent };